import { DownloadCSV } from '../../core/slots/DownloadCSV.js';
import { DISPLAY_NAME } from '../constants.js';

export const HoneycombChartDownloadCSVSlot = DownloadCSV(DISPLAY_NAME);
